import {
  GET_MY_QRS,
  GET_INFO_FOR_FIND_PET,
  DELETE_MY_QR,
  GET_OVERALL_STATISTICS,
  CLAIM_QR_CODE,
  CLAIM_QR_CODE_SUCCESS,
  CLAIM_QR_CODE_ERROR,
  UPDATE_CLAIMED_QR,
  CLEAR_CLAIM_STATE,
  OWNER_LOGIN,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_ERROR,
  OWNER_UPDATE_QR,
  OWNER_TOGGLE_LOST,
  OWNER_LOGOUT,
  SEND_OTP,
  SEND_OTP_SUCCESS,
  SEND_OTP_ERROR,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_ERROR,
  CLEAR_OTP_STATE,
} from "../actions/types";

const INITIAL_STATE = {
  myQRS: null,
  findPetInfo: null,
  overallStatistics: {},
  // Claim state
  claimLoading: false,
  claimSuccess: false,
  claimError: null,
  // Owner login state
  ownerLoginLoading: false,
  ownerLoggedIn: false,
  ownerLoginError: null,
  // OTP verification state
  otpSending: false,
  otpSent: false,
  otpSendError: null,
  otpPhoneNumber: null,
  otpVerifying: false,
  otpVerifyError: null,
  otpSecondsRemaining: 0,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_MY_QRS:
      return { ...state, myQRS: action.payload };
    case GET_INFO_FOR_FIND_PET:
      return { ...state, findPetInfo: action.payload };
    case DELETE_MY_QR:
      return {
        ...state,
        myQRS: state.myQRS.filter(
          (value) => value.id !== action.payload,
        ),
      };
    case GET_OVERALL_STATISTICS:
      return { ...state, overallStatistics: action.payload };

    // Claim QR code actions
    case CLAIM_QR_CODE:
      return {
        ...state,
        claimLoading: true,
        claimError: null,
      };
    case CLAIM_QR_CODE_SUCCESS:
      return {
        ...state,
        claimLoading: false,
        claimSuccess: true,
        claimError: null,
        findPetInfo: {
          ...state.findPetInfo,
          ...action.payload,
          status: "claimed",
        },
      };
    case CLAIM_QR_CODE_ERROR:
      return {
        ...state,
        claimLoading: false,
        claimSuccess: false,
        claimError: action.payload,
      };
    case UPDATE_CLAIMED_QR:
      return {
        ...state,
        findPetInfo: {
          ...state.findPetInfo,
          ...action.payload,
        },
      };
    case CLEAR_CLAIM_STATE:
      return {
        ...state,
        claimLoading: false,
        claimSuccess: false,
        claimError: null,
      };

    // Owner login actions
    case OWNER_LOGIN:
      return {
        ...state,
        ownerLoginLoading: true,
        ownerLoginError: null,
      };
    case OWNER_LOGIN_SUCCESS:
      return {
        ...state,
        ownerLoginLoading: false,
        ownerLoggedIn: true,
        ownerLoginError: null,
      };
    case OWNER_LOGIN_ERROR:
      return {
        ...state,
        ownerLoginLoading: false,
        ownerLoggedIn: false,
        ownerLoginError: action.payload,
      };
    case OWNER_UPDATE_QR:
      return {
        ...state,
        findPetInfo: {
          ...state.findPetInfo,
          ...action.payload,
        },
      };
    case OWNER_TOGGLE_LOST:
      return {
        ...state,
        findPetInfo: {
          ...state.findPetInfo,
          marked_as_lost: action.payload.marked_as_lost,
        },
      };
    case OWNER_LOGOUT:
      return {
        ...state,
        ownerLoggedIn: false,
        ownerLoginError: null,
      };

    // OTP verification actions
    case SEND_OTP:
      return {
        ...state,
        otpSending: true,
        otpSent: false,
        otpSendError: null,
      };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        otpSending: false,
        otpSent: true,
        otpSendError: null,
        otpPhoneNumber: action.payload.phoneNumber,
        otpSecondsRemaining: action.payload.expires_in_seconds || 180,
      };
    case SEND_OTP_ERROR:
      return {
        ...state,
        otpSending: false,
        otpSent: false,
        otpSendError: action.payload,
        otpSecondsRemaining: action.payload.seconds_remaining || 0,
      };
    case VERIFY_OTP:
      return {
        ...state,
        otpVerifying: true,
        otpVerifyError: null,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        otpVerifying: false,
        otpVerifyError: null,
        otpSent: false,
        otpPhoneNumber: null,
      };
    case VERIFY_OTP_ERROR:
      return {
        ...state,
        otpVerifying: false,
        otpVerifyError: action.payload,
      };
    case CLEAR_OTP_STATE:
      return {
        ...state,
        otpSending: false,
        otpSent: false,
        otpSendError: null,
        otpPhoneNumber: null,
        otpVerifying: false,
        otpVerifyError: null,
        otpSecondsRemaining: 0,
      };

    default:
      return state;
  }
};
